import React, { useState } from 'react';
import { Textarea } from '@econsult/econsult-ui/dist/components/Textarea';
import Button from 'components/Button';
import styled from 'styled-components';
import { sendFeedback } from 'store/action/feedback';
import * as styles from '../Summary/styles';

interface FeedbackModalProps {
    closeModal: () => void;
}

const StyledTextarea = styled(Textarea)`
  .MuiInputBase-input {
    color: #333333 !important;
  }
`;

export const FeedbackModal: React.FC<FeedbackModalProps> = ({
  closeModal,
}) => {
  const [comment, setComment] = useState('');

  const handleSave = () => {
    sendFeedback(comment, {});
    closeModal();
  };

  return (
    <>
      <div style={{ marginBottom: '1rem', color: '#333333' }}>
        <StyledTextarea
          fullWidth
          autoFocus
          multiline
          minRows={4}
          maxRows={4}
          id="feedback-textarea"
          placeholder="How could Hi&nbsp;Scribe be improved?"
          style={{ fontSize: '16px', color: '#333333 !important' }}
          sx={{ color: '#333 !important' }}
          onChange={(event: { target: { value: React.SetStateAction<string>; }; }) => setComment(event.target.value)}
        />
      </div>
      <styles.FlexGroup>
        <Button
          id="feedback-cancel-modal-button"
          onClick={closeModal}
          buttonText="Cancel"
          icon={null}
          iconPosition="left"
          state="secondary"
          disabled={false}
        />
        <Button
          id="feedback-send-modal-button"
          onClick={handleSave}
          buttonText="Send"
          icon={null}
          iconPosition="left"
          state="primary"
          disabled={!comment}
        />
      </styles.FlexGroup>
    </>
  );
};
